var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.2,
    width: 35.6,
    height: 25.6,
    fill: "#F9F9F9",
    stroke: "url(#paint0_linear)",
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5617 7.67827L13.103 16.1374C13.0064 16.234 12.9405 16.357 12.9137 16.4909C12.9137 16.4909 12.9137 16.4909 12.9137 16.4909L12.5735 18.1919L14.2739 17.8517C14.4078 17.8249 14.5308 17.7591 14.6274 17.6625L23.0874 9.20343C23.2794 9.00015 23.385 8.73019 23.3819 8.45041C23.3787 8.16837 23.2653 7.89879 23.0658 7.69937C22.8663 7.49996 22.5967 7.38657 22.3147 7.38349C22.0349 7.38043 21.7649 7.48618 21.5617 7.67827ZM12.1247 15.1592C12.1247 15.1592 12.1247 15.1592 12.1247 15.1592L20.5894 6.69403L20.6003 6.68338C21.0653 6.23836 21.6861 5.99311 22.3298 6.00015C22.9734 6.00718 23.5887 6.26594 24.0439 6.72101C24.4991 7.17608 24.7581 7.79129 24.7653 8.43491C24.7725 9.07852 24.5274 9.69938 24.0825 10.1645L24.0717 10.1756L15.6057 18.6407C15.6056 18.6407 15.6057 18.6407 15.6057 18.6407C15.316 18.9304 14.947 19.1279 14.5453 19.2083C14.5452 19.2083 14.5453 19.2083 14.5453 19.2083L11.8274 19.7519C11.6006 19.7973 11.3662 19.7263 11.2026 19.5628C11.0391 19.3993 10.9681 19.1648 11.0134 18.938L11.5571 16.2196C11.6375 15.8179 11.835 15.4489 12.1247 15.1592Z",
    fill: "#9BD73E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3154 18.5255L12.2402 16.4504L13.2185 15.4722L15.2937 17.5473L14.3154 18.5255Z",
    fill: "#9BD73E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2324 11.6085L19.1572 9.53341L20.1355 8.55518L22.2107 10.6303L21.2324 11.6085Z",
    fill: "#9BD73E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 24.6815,
    y2: 34.1744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.6ed71fcdeba6a30bc60bd912cab5dc51.svg";
export { ForwardRef as ReactComponent };